import { DynamicField } from './dynamic-field.model';

export class DynamicFormTextBox extends DynamicField {
  override controlType = 'textbox';
  override type: string;

  constructor(options: { [x in string]: any } = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}
